module.exports = __webpack_public_path__ + "img/logo_brkoeln.4ed24f11.png";